import { SVGProps } from 'react';

export const SvgUserSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1727 16.3636C17.6213 16.3636 16.3636 17.6213 16.3636 19.1727C16.3636 20.7241 17.6213 21.9817 19.1727 21.9817C20.7241 21.9817 21.9818 20.7241 21.9818 19.1727C21.9818 17.6213 20.7241 16.3636 19.1727 16.3636ZM15 19.1727C15 16.8682 16.8682 15 19.1727 15C21.4773 15 23.3455 16.8682 23.3455 19.1727C23.3455 21.4772 21.4773 23.3454 19.1727 23.3454C16.8682 23.3454 15 21.4772 15 19.1727Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7452 21.7452C22.0114 21.4789 22.4431 21.4789 22.7094 21.7452L23.8003 22.8361C24.0666 23.1023 24.0666 23.534 23.8003 23.8003C23.534 24.0666 23.1023 24.0666 22.8361 23.8003L21.7452 22.7094C21.4789 22.4431 21.4789 22.0115 21.7452 21.7452Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2233 1.41176C7.5592 1.41176 5.38344 3.61503 5.38344 6.35294C5.38344 9.09085 7.5592 11.2941 10.2233 11.2941C12.8875 11.2941 15.0632 9.09085 15.0632 6.35294C15.0632 3.61503 12.8875 1.41176 10.2233 1.41176ZM3.97919 6.35294C3.97919 2.85328 6.76592 0 10.2233 0C13.6807 0 16.4675 2.85328 16.4675 6.35294C16.4675 9.8526 13.6807 12.7059 10.2233 12.7059C6.76592 12.7059 3.97919 9.8526 3.97919 6.35294ZM10.2233 16.0941C5.22513 16.0941 1.40425 19.4339 1.40425 23.2941C1.40425 23.684 1.0899 24 0.702123 24C0.314351 24 0 23.684 0 23.2941C0 18.4127 4.71387 14.6824 10.2233 14.6824C11.4445 14.6824 12.622 14.8618 13.7202 15.1987C14.0911 15.3125 14.3 15.707 14.1868 16.0799C14.0736 16.4528 13.6812 16.6628 13.3103 16.549C12.3469 16.2535 11.3076 16.0941 10.2233 16.0941Z"
    />
  </svg>
);
